import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';

import { PagesComponent } from './pages.component';
import { NotFoundComponent } from './miscellaneous/not-found/not-found.component';
import { ECommerceComponent } from './e-commerce/e-commerce.component';
import { InviteProviderComponent } from './invite-provider/invite-provider.component';
import { CompanySearchComponent } from './miscellaneous/company-search/company-search.component';
import { MiscellaneousComponent } from './miscellaneous/miscellaneous.component';
import { InviteComponent } from './miscellaneous/invite/invite.component';

const routes: Routes = [{
    path: '',
    component: PagesComponent,
    children: [
        {
            path: 'dashboard',
            component: ECommerceComponent,
        },
        {
            path: 'users',
            loadChildren: () => import('./users/users.module')
                .then(m => m.UsersModule),
        },
        {
            path: 'orders',
            loadChildren: () => import('./orders/orders.module')
                .then(m => m.OrdersModule),
        },
        {
            path: 'orders-items',
            loadChildren: () => import('./orders-item/orders-item.module')
                .then(m => m.OrderItemModule),
        },
        {
            path: 'paymentconditions',
            loadChildren: () => import('./paymentconditions/payment-conditions.module')
                .then(m => m.PaymentConditionsModule),
        },
        {
            path: 'unitmeasurament',
            loadChildren: () => import('./unitmeasurements/unit-measurement.module')
                .then(m => m.UnitMeasuramentModule),
        },
        {
            path: 'coins',
            loadChildren: () => import('./coins/coins.module')
                .then(m => m.CoinsModule),
        },
        {
            path: 'company',
            loadChildren: () => import('./companys/companys.module')
                .then(m => m.CompanysModule),
        },
        {
            path: 'providers',
            loadChildren: () => import('./providers/providers.module')
                .then(m => m.ProvidersModule),
        },
        {
            path: 'requests',
            loadChildren: () => import('./requests/requests.module')
                .then(m => m.RequestsModule),
        },
        {
            path: 'items',
            loadChildren: () => import('./items/items.module')
                .then(m => m.ItemsModule),
        },
        {
            path: 'requisition-items',
            loadChildren: () => import('./requisition-items/requisition-items.module')
                .then(m => m.RequisitionItemsModule),
        },
        {
            path: 'quotes',
            loadChildren: () => import('./quote/quotes.module')
                .then(m => m.QuotesModule),
        },
        {
            path: 'quote-items',
            loadChildren: () => import('./quote-items/quote-items.module')
                .then(m => m.QuoteItemsModule),
        },
        {
            path: 'quote-provider',
            loadChildren: () => import('./quote-provider/quote-provider.module')
                .then(m => m.QuoteProviderModule),
        },
        {
            path: 'quote-provider-item',
            loadChildren: () => import('./quote-provider-items/quote-provider-items.module')
                .then(m => m.QuoteProviderItemsModule),
        },
        {
            path: 'invite',
            component: InviteComponent,
        },
        // {
        //     path: 'chat',
        //     loadChildren: () => import('./chat/chat.module').then(m => m.ChatModule)
        // },
        {
            path: '',
            redirectTo: 'dashboard',
            pathMatch: 'full',
        },
        {
            path: '**',
            component: NotFoundComponent,
        },
    ],
}];




@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class PagesRoutingModule {
}
